<script setup>
import MainHeader from "@/Layouts/MainHeader.vue";
import Header from "@/Layouts/Header.vue";
import Tracking from '@/Components/ResourseLoader.vue'
import BreadcrumbsUslugi from "@/Components/BreadcrumbsUslugi.vue";
import Body from "@/Layouts/Body.vue";
import Seodesc from "@/Components/Seodesc.vue";
import Seoquestion from "@/Components/Seoquestion.vue";
import RevealPhone from "@/Components/RevealPhone.vue";
import CategoryFilter from "@/Components/CategoryFilter.vue";
import CourtPracticeWidget from "@/Components/CourtPracticeWidget.vue";
import OfferCard from "@/Components/OfferCard.vue";
import FactHint from "@/Components/FactHint.vue";
import RatingReady from "@/Components/RatingReady.vue";
import Pagination from "@/Components/Pagination.vue";
import UslugaDocuments from "@/Layouts/UslugaDocuments.vue";
import UslugaReviews from "@/Layouts/UslugaReviews.vue";
import RelatedArticles from "@/Layouts/RelatedArticles.vue";
import UserQuestions from "@/Layouts/UserQuestions.vue";
import RelatedSpecialties from "@/Components/RelatedSpecialties.vue";
import WorkSteps from "@/Layouts/WorkSteps.vue";
import MainFooter from "@/Layouts/MainFooter.vue";
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { Head, Link } from "@inertiajs/vue3";
import axios from 'axios';

let set = defineProps({
  city: Object,
  main_usluga: Object,
  second_usluga: Object,
  uslugi: Object,
  cities: Object,
  allsities: Object,
  category: Object,
  routeurl: String,
  count: Number,      // всего офферов по всем страницам
  lawyers: Number,    // из них уникальных юристов
  offers_real: Number,
  priceBreakdown: { type: Array, default: () => [] },
  max: Number,
  min: Number,
  countrating: Number,
  sumrating: Number,
  getLawyer: String,
  auth: Object,
  cityheader: Object,
  backendurl: String,
  documents: { type: Array, default: () => [] },
  reviews: { type: Array, default: () => [] },
  reviewsMeta: { type: Object, default: () => ({}) },
  relatedOffers: { type: Boolean, default: false },
  relatedParent: { type: String, default: null },
  offerReviews: { type: Object, default: () => ({}) },
  offerStats: { type: Object, default: () => ({}) },
  replySpeed: { type: Object, default: () => ({}) },
  offerRating: { type: Object, default: () => ({}) },  // user_id -> {avg, count} по этой услуге и городу
  situations: { type: Array, default: () => [] },   // «Что у вас произошло?»
  perks: { type: Object, default: () => ({}) },       // user_id -> значки   // user_id -> «обычно отвечает за час»
  diplomas: { type: Object, default: () => ({}) },    // user_id -> { items: [превью], total }
  categoryCases: { type: Number, default: 0 },
  articles: { type: Array, default: () => [] },
  practice: { type: Array, default: () => [] },
  userQuestions: { type: Object, default: () => ({ items: [], total: 0 }) },
  questionsUrl: { type: String, default: "/questions" },
  // Режим «пригласить юристов» — задаётся, только если автор вопроса пришёл по ссылке ?invite=
  inviteContext: { type: Object, default: null },
  // id дежурных юристов «сейчас на сайте» (имитация присутствия)
  onlineLawyerIds: { type: Array, default: () => [] },
  // Виджет судебной практики «Что решают суды по вашему делу» (null, если нет данных)
  courtPractice: { type: Object, default: null },
  // Профили юристов города, отметивших это направление в кабинете, без своего оффера здесь
  cityLawyers: { type: Array, default: () => [] },
});

// Приглашение юристов автором вопроса (до 3). Состояние локальное + синхронизация с сервером.
const invitedIds = ref(set.inviteContext ? [...set.inviteContext.invited] : []);
const inviteBusy = ref(false);
const inviteError = ref('');
const inviteNote = ref('');
const onToggleInvite = (lawyerId) => {
  if (!set.inviteContext || inviteBusy.value) return;
  inviteBusy.value = true;
  inviteError.value = '';
  axios.post(route('questions.invite', set.inviteContext.questionId), { lawyer_id: lawyerId })
    .then(({ data }) => {
      invitedIds.value = data.invited;
      if (data.answering) {
        inviteNote.value = 'Юрист приглашён и уже готовит ответ — он появится на странице вопроса в течение минуты. Можно вернуться позже или дождаться письма на почту.';
      }
    })
    .catch((e) => { inviteError.value = e?.response?.data?.message || 'Не удалось сохранить приглашение'; })
    .finally(() => { inviteBusy.value = false; });
};

// ВАЖНО: всё производное от пропсов — computed, иначе при смене города Inertia
// переиспользует компонент без пересоздания и значения остаются старыми (h1/title
// не обновлялись до перезагрузки).
// Гео-нейтральная категория (напр. электроснабжение) — не привязана к городу
// посетителя, поэтому город из заголовков/H1/описания убираем.
const geoNeutral = computed(() => !!set.main_usluga?.is_geo_neutral);

// Кнопка «Редактировать» для админа: правит контент категории/подкатегории этой страницы
const isAdmin = computed(() => set.auth?.isadmin == 1);
const editUslugaId = computed(() => set.second_usluga?.id || set.main_usluga?.id || null);
const cityName  = computed(() => geoNeutral.value ? '' : (set.city?.title || 'России'));
const cityPrep  = computed(() => geoNeutral.value ? '' : (set.city?.title || 'по всей России'));
// Город с ведущим пробелом для подстановки в заголовок (пусто у гео-нейтральных)
const cityPart  = computed(() => cityPrep.value ? ` ${cityPrep.value}` : '');
const mainName  = computed(() => set.main_usluga?.usl_name || 'Услуги юристов');
const secName   = computed(() => set.second_usluga?.usl_name || null);

// Чистый h1 одной фразой (без крошек-ссылок)
const cityTitle = computed(() => {
  if (geoNeutral.value) return '';
  const rc = set.city?.title || '';
  return (rc && rc !== 'Все регионы') ? rc : '';
});
const h1Text = computed(() => {
  const svc = set.second_usluga?.usl_name
    || (set.main_usluga && set.main_usluga.url != 0 ? set.main_usluga.usl_name : null);
  if (svc) return cityTitle.value ? `${svc} — ${cityTitle.value}` : svc;
  return cityTitle.value ? `Юридические услуги — ${cityTitle.value}` : 'Юридические услуги';
});
const count     = computed(() => set.count || 0);
// «4 года», «5 лет» — для стажа в блоке юристов города
function yearsWord(n) {
  const a = Math.abs(Number(n)) % 100, b = a % 10;
  if (a > 10 && a < 20) return 'лет';
  if (b > 1 && b < 5) return 'года';
  return b === 1 ? 'год' : 'лет';
}
// В заголовках и подписях мы обещаем ЮРИСТОВ, а не карточек: у одного юриста
// может быть до двух офферов. По наследственному юристу в Симферополе: 15 и 12.
const lawyerCount = computed(() => set.lawyers || set.count || 0);

/** Склонение после числа: 1 юрист, 2 юриста, 5 юристов (11-14 — исключение). */
const plural = (n, one, few, many) => {
  const t = Math.abs(n) % 100;
  if (t >= 11 && t <= 14) return many;
  const o = t % 10;
  return o === 1 ? one : (o >= 2 && o <= 4 ? few : many);
};

// «15 услуг от 12 юристов». Раньше здесь было «найдено юристов: N», где N —
// число карточек на текущей странице. У одного юриста бывает до двух услуг, и на
// второй странице видны те же люди — поэтому числа разведены.
const offersLine = computed(() => {
  const o = count.value;
  const l = lawyerCount.value;
  if (!o) return '';
  const services = `${o} ${plural(o, 'услуга', 'услуги', 'услуг')}`;
  if (!l || l === o) return services;
  return `${services} от ${l} ${plural(l, 'юриста', 'юристов', 'юристов')}`;
});
const minPrice  = computed(() => set.min || null);
// Текущая страница пагинации (1 — базовый чистый URL)
const currentPage = computed(() => Number(set.uslugi?.current_page) || 1);
// Суффикс для title/description на страницах пагинации >1 — чтобы серия не выглядела дублями
const pageSuffix = computed(() => currentPage.value > 1 ? ` — страница ${currentPage.value}` : '');

// Агрегатор цен по типам услуг (Консультация, Иск...) — из офферов страницы
const priceRows = computed(() => set.priceBreakdown || []);
const priceLow  = computed(() => priceRows.value.length ? Math.min(...priceRows.value.map(p => p.mn)) : null);
const priceHigh = computed(() => priceRows.value.length ? Math.max(...priceRows.value.map(p => p.mx)) : null);
const fmtPrice  = (n) => Number(n).toLocaleString('ru-RU');

/**
 * Цифры для полосы фактов.
 *
 * ⚠ Старое catCases считало СТАТЬИ и вдобавок подставляло 100, когда данных
 * нет, — то есть показывало выдуманное число. Убрано целиком.
 */
const ratingValue = computed(() =>
  set.sumrating && set.countrating ? Number((set.sumrating / set.countrating).toFixed(2)) : null
);
const reviewsWord = computed(() => plural(set.countrating || 0, 'отзыв', 'отзыва', 'отзывов'));
const courtCasesCount = computed(() => {
  return Number(set.courtPractice?.total) || 0;
});
const hasFacts = computed(() =>
  !!(set.lawyers || ratingValue.value || priceLow.value || set.min || courtCasesCount.value)
);


// Калькулятор: выбор услуг → суммарная средняя стоимость
const selectedPrices = ref([]);
/**
 * Ситуации: «Отказ от медосвидетельствования», «Двойная сплошная».
 *
 * Человек с протоколом на руках ищет не «юриста по лишению прав», а свой
 * случай. Панель раскрывается прямо здесь: увести его на отдельную страницу
 * значит потерять список юристов, ради которого он сюда дошёл.
 *
 * Выбор пишется в адрес (?situation=…) — ссылкой можно поделиться, и в
 * Метрике видно, какие ситуации выбирают чаще. Канонический адрес остаётся
 * прежним: это фильтр, а не отдельная страница.
 */
const openSituation = ref(null);

onMounted(() => {
  const slug = new URLSearchParams(window.location.search).get('situation');
  if (slug && set.situations.some((x) => x.slug === slug)) openSituation.value = slug;
});

const activeSituation = computed(
  () => set.situations.find((x) => x.slug === openSituation.value) || null
);

function pickSituation(slug) {
  openSituation.value = openSituation.value === slug ? null : slug;

  const u = new URL(window.location.href);
  if (openSituation.value) u.searchParams.set('situation', openSituation.value);
  else u.searchParams.delete('situation');
  window.history.replaceState({}, '', u);

  if (window.goal) window.goal('SITUATION_PICK');
}

// Блок «Стоимость услуг» свёрнут по умолчанию (экономия места)
const priceOpen = ref(false);
const calcTotal = computed(() =>
  priceRows.value.filter(p => selectedPrices.value.includes(p.name))
    .reduce((s, p) => s + (Number(p.avg) || 0), 0)
);

// Title.
//
// Собирается ПО БЮДЖЕТУ. Раньше шаблон был жёсткий, и на длинных названиях
// тайтл доходил до 88 символов — поисковики режут примерно на 60 символах кириллицы,
// и до читателя не доходило ни число юристов, ни «цены», ни бренд — одно название с многоточием.
//
// Теперь обязательная часть — название с городом и номер страницы (без него серия
// пагинации выглядит дублями), а дальше по убыванию ценности добавляется то, что влезает.
// Бренд идёт последним: домен в выдаче и так показан отдельной строкой.
// Строка выдачи — около 600 пкс, для кириллицы это примерно 65 символов.
// Брали 60 — оказалось слишком строго: у «Определения места жительства
// ребенка» число юристов не влезало ровно на один символ.
const TITLE_MAX = 65;

const title = computed(() => {
  const c = lawyerCount.value;
  const isSecond = !!secName.value;
  const isMain = !isSecond && set.main_usluga?.url !== '0';

  const base = isSecond || isMain
    ? `${isSecond ? secName.value : mainName.value}${cityPart.value}`
    : `Юристы${cityName.value ? ' ' + cityName.value : ''}`;

  // Номер страницы обязателен — иначе вторая и третья страницы получают
  // тот же тайтл, что и первая. Место под него резервируем заранее, а
  // приписываем в конце: если ставить сразу, он вытесняет число юристов,
  // а оно ценнее.
  const pageMark = currentPage.value > 1 ? `, стр. ${currentPage.value}` : '';
  const brand = ' | nedicom.ru';

  const optional = [];
  if (isSecond) optional.push(` — ${c} ${plural(c, 'юрист', 'юриста', 'юристов')}`);
  else if (isMain) optional.push(` — ${c} ${plural(c, 'специалист', 'специалиста', 'специалистов')}`);
  else optional.push(' — консультация');
  optional.push(', цены');
  if (!isMain) optional.push(', отзывы');

  const budget = TITLE_MAX - pageMark.length;
  let out = base;
  for (const part of optional) {
    if ((out + part).length <= budget) out += part;
  }
  out += pageMark;

  // Бренд — в самую последнюю очередь: домен в выдаче и так виден отдельной строкой.
  if ((out + brand).length <= TITLE_MAX) out += brand;
  return out;
});

// Description — начинаем с ключа (а не с голого числа офферов), число даём как соц-proof в середине
const description = computed(() => {
  const c = lawyerCount.value;
  const sfx = c === 1 ? '' : c < 5 ? 'а' : 'ов';
  const priceStr = minPrice.value ? ` от ${minPrice.value.toLocaleString('ru-RU')} ₽` : '';
  const ps = currentPage.value > 1 ? ` Страница ${currentPage.value}.` : '';
  if (secName.value) {
    return `${secName.value}${cityPart.value}${priceStr}: ${c} юрист${sfx} с реальными офисами и личным приёмом. Честно оценим перспективы дела по вашему вопросу.${ps}`;
  }
  if (set.main_usluga?.url !== '0') {
    return `${mainName.value}${cityPart.value}${priceStr}: ${c} юрист${sfx} с реальными офисами, личным приёмом и отзывами клиентов. Оценим перспективы дела до предложения услуги.${ps}`;
  }
  return `Юристы${cityPart.value}${priceStr}: ${c} специалист${sfx} с реальными офисами и личным приёмом. Сначала оцениваем перспективы — потом предлагаем решение.${ps}`;
});

// Canonical: на страницах пагинации >1 каноникал ведёт на САМУ СЕБЯ (?page=N),
// а не на 1-ю страницу — иначе противоречие с index,follow + rel prev/next и
// потеря из индекса офферов, которые есть только на 2-3 странице.
const canonicalUrl = computed(() => {
  const base = 'https://nedicom.ru/' + (set.backendurl || '');
  return currentPage.value > 1 ? `${base}?page=${currentPage.value}` : base;
});

// Техническая страница «все регионы» (all-cities, city.id=0) — на её базе строится фид.
// Это дубль реальных городских страниц, в индекс не пускаем.
const isTechCity = computed(() => set.city?.id === 0 || set.city?.url === 'all-cities');
// offers_real — реальные офферы без карточек-фолбэка (count может быть раздут фолбэком)
const offersReal = computed(() => set.offers_real ?? count.value);
const robotsContent = computed(() => {
  // Пагинация: в индексе держим только 1-ю (чистую) страницу категории, чтобы Google
  // не показывал ?page=N вместо главной. Страницы 2+ — noindex, но FOLLOW: офферы,
  // которые есть только на 2-3 странице, всё равно индексируются своими карточками
  // (страница оффера index,follow, самоканоникал). Так убираем дубли-?page из выдачи.
  if (currentPage.value > 1) return 'noindex, follow';
  if (isTechCity.value) return 'noindex, follow';
  // Гео-нейтральная услуга индексируется только в городах с реальными офферами
  if (geoNeutral.value) return offersReal.value > 0 ? 'index, follow' : 'noindex, follow';
  return count.value > 0 ? 'index, follow' : 'noindex, follow';
});

// Pagination. page=1 — это базовый URL, поэтому rel=prev на 1-ю страницу
// должен вести на чистый адрес, а не на ?page=1 (иначе дубль каноникала).
const cleanPageUrl = (url) => {
  if (!url) return null;
  try {
    const u = new URL(url, 'https://nedicom.ru');
    if (u.searchParams.get('page') === '1') u.searchParams.delete('page');
    const qs = u.searchParams.toString();
    return u.origin + u.pathname + (qs ? '?' + qs : '');
  } catch {
    return url;
  }
};
const prevUrl = computed(() => cleanPageUrl(set.uslugi?.links?.[0]?.url || null));
const nextUrl = computed(() => cleanPageUrl(set.uslugi?.links?.at(-1)?.url || null));

// OG Image
const imageUrl = computed(() => {
  const p = set.second_usluga?.file_path || set.main_usluga?.file_path;
  return p ? `https://nedicom.ru/${p}` : 'https://nedicom.ru/court.webp';
});

const childRef = ref(null);

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

// Наличие блоков для якорных ссылок в сайдбаре
const hasDocuments = computed(() => !!(set.documents && set.documents.length));
const hasQuestions = computed(() => !!(set.second_usluga ?? set.main_usluga)?.popular_question);
const hasReviews = computed(() => !!(set.reviews && set.reviews.length));

// Мобильная навигация по секциям страницы (активная секция)
const activeSection = ref('description');
let sectionObserver = null;
onMounted(() => {
  const ids = ['court-practice', 'reviews', 'consultation', 'description', 'questions', 'documents'];
  sectionObserver = new IntersectionObserver(
    entries => entries.forEach(e => { if (e.isIntersecting) activeSection.value = e.target.id; }),
    { rootMargin: '-20% 0px -70% 0px' }
  );
  ids.forEach(id => { const el = document.getElementById(id); if (el) sectionObserver.observe(el); });
});
onUnmounted(() => sectionObserver?.disconnect());
</script>

<template>

  <Head>
    <title>{{ title }}</title>
    <meta name="description" :content="description" />
    <link rel="canonical" :href="canonicalUrl" />
    <link v-if="prevUrl" rel="prev" :href="prevUrl" />
    <link v-if="nextUrl" rel="next" :href="nextUrl" />
    <meta name="robots" :content="robotsContent" />
    <meta property="og:title" :content="title" />
    <meta property="og:description" :content="description" />
    <meta property="og:type" content="website" />
    <meta property="og:url" :content="canonicalUrl" />
    <meta property="og:site_name" content="nedicom.ru" />
    <meta property="og:locale" content="ru_RU" />
    <meta property="og:image" :content="imageUrl" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" :content="title" />
    <meta name="twitter:description" :content="description" />
    <meta name="twitter:image" :content="imageUrl" />
  </Head>

  <div class="min-h-screen overflow-x-clip">
    <MainHeader :auth="set.auth" :city="set.city" ref="childRef" :mainurl="set.main_usluga?.url || null"
      :secondurl="set.second_usluga ? set.second_usluga.url : null" :reloadpage="true" />

    <!-- Мобильная навигация по секциям страницы -->
    <nav class="lg:hidden sticky top-12 z-30 bg-white border-b border-gray-200 shadow-sm">
      <div class="flex overflow-x-auto" style="scrollbar-width:none;-ms-overflow-style:none">
        <a v-if="set.courtPractice" href="#court-practice" data-id="court-practice"
          class="flex-shrink-0 px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors"
          :class="activeSection === 'court-practice' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700'"
        >Что решают суды</a>
        <a v-if="hasReviews" href="#reviews" data-id="reviews"
          class="flex-shrink-0 px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors"
          :class="activeSection === 'reviews' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700'"
        >Отзывы</a>
        <a href="#consultation" data-id="consultation"
          class="flex-shrink-0 px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors"
          :class="activeSection === 'consultation' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700'"
        >Консультация</a>
        <a href="#description" data-id="description"
          class="flex-shrink-0 px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors"
          :class="activeSection === 'description' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700'"
        >Описание</a>
        <a v-if="hasQuestions" href="#questions" data-id="questions"
          class="flex-shrink-0 px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors"
          :class="activeSection === 'questions' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700'"
        >Вопросы</a>
        <a v-if="hasDocuments" href="#documents" data-id="documents"
          class="flex-shrink-0 px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors"
          :class="activeSection === 'documents' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700'"
        >Документы</a>
        <button type="button" @click="scrollToTop"
          class="flex-shrink-0 ml-auto px-4 py-2.5 text-sm font-medium whitespace-nowrap text-indigo-600 inline-flex items-center gap-1">
          <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
          </svg>
          Наверх
        </button>
      </div>
    </nav>

    <Body>
      <div class="max-w-7xl mx-auto bg-white grid grid-cols-1 md:grid-cols-4 px-4 py-6">
        <div class="flex flex-col">
          <CategoryFilter :category="set.category" :cityUrl="set.city.url"
            :main_usluga_url="set.main_usluga.url ? set.main_usluga.url : '0'" :second_usluga_url="set.second_usluga ? set.second_usluga.url : 'false'"
            :has-questions="hasQuestions" :has-documents="hasDocuments"
            :has-court="!!set.courtPractice"
            :has-reviews="hasReviews" :has-articles="!!((set.articles && set.articles.length) || (set.practice && set.practice.length))" :has-cities="!!set.allsities" />
        </div>

        <div class="w-full h-full col-span-3 md:pl-10" itemscope itemtype="https://schema.org/LegalService">
          <meta v-if="set.second_usluga" itemprop="image"
            :content="'https://nedicom.ru/' + set.second_usluga.file_path" />
          <meta v-else itemprop="image" :content="'https://nedicom.ru/' + set.main_usluga.file_path" />
          <meta itemprop="name" :content="title" />

          <div class="my-6 md:mb-0">
            <h1 class="md:mb-4 flex md:justify-start justify-center leading-tight text-gray-900 text-2xl lg:text-3xl font-extrabold tracking-tight">
              {{ h1Text }}
            </h1>

            <a v-if="isAdmin && editUslugaId" :href="route('uslugi.edit', editUslugaId)" target="_blank"
              class="inline-flex items-center gap-1.5 mb-3 px-3 py-1.5 text-xs font-medium rounded-lg border border-indigo-200 bg-indigo-50 text-indigo-700 hover:bg-indigo-100 transition-colors">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              Редактировать {{ set.second_usluga ? 'подкатегорию' : 'категорию' }}
            </a>

            <p itemprop="description" class="flex md:justify-start justify-center my-5">
              <span v-if="set.second_usluga">{{
                set.second_usluga.usl_desc
              }}</span>
              <span v-else>{{ set.main_usluga.usl_desc }}</span>
            </p>

            <!-- ⚠ ЗДЕСЬ БЫЛА СТРОКА «N дел в практике». Убрана.
                 Число бралось из uslugis_practice — а это пивот «оффер ↔ СТАТЬЯ»,
                 то есть считались публикации юристов, а не дела. Хуже: запрос
                 собирал офферы по main OR second, поэтому на подуслуге выходило
                 то же самое число, что и у всей категории (проверено: 821 и там,
                 и там). Цифра, одинаковая на всех страницах ветки, не говорит
                 о странице ничего. И совсем плохо было рядом: строкой ниже
                 стояло «ориентир по 1 реальному делу» — настоящее число из базы
                 судебной практики. Два числа про «дела», отличающиеся в
                 восемьсот раз, отменяли доверие к обоим.
                 Факты переехали в полосу ниже, где у каждого своя подпись. -->

          </div>

          <!-- Режим «пригласить юристов»: инструкция автору вопроса -->
          <div v-if="set.inviteContext" class="mb-5 rounded-xl border border-indigo-200 bg-indigo-50 px-4 py-3">
            <p class="text-sm font-semibold text-indigo-900">Пригласите юристов ответить на ваш вопрос</p>
            <p class="text-xs text-indigo-700 mt-1 leading-relaxed">
              Приглашать можно юристов с пометкой <span class="inline-flex items-center gap-1 align-middle"><span class="inline-flex h-1.5 w-1.5 rounded-full bg-green-500"></span><b>онлайн</b></span> — они ответят быстро.
              Нажмите «Пригласить» на карточке (до {{ set.inviteContext.max }} юристов).
              Приглашено: <b>{{ invitedIds.length }}</b> из {{ set.inviteContext.max }}.
              Ответ появится на странице вопроса, а также придёт вам на почту.
            </p>
            <div class="mt-2 flex flex-wrap items-center gap-3">
              <a :href="'/questions/' + set.inviteContext.questionUrl"
                class="text-xs font-medium text-indigo-700 underline">← вернуться к вопросу</a>
              <span v-if="inviteError" class="text-xs text-red-600">{{ inviteError }}</span>
            </div>
            <div v-if="inviteNote" class="mt-2 rounded-lg border border-green-200 bg-green-50 px-3 py-2.5">
              <p class="text-xs text-green-800 leading-relaxed">{{ inviteNote }}</p>
              <a :href="'/questions/' + set.inviteContext.questionUrl"
                class="mt-2 inline-flex items-center gap-1.5 rounded-lg bg-green-600 hover:bg-green-700 text-white text-xs font-semibold px-3.5 py-2 transition-colors">
                Перейти к вопросу и посмотреть ответ
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          </div>

          <!-- ПОЛОСА ФАКТОВ.
               Раньше это были три строки подряд одного веса: дела, рейтинг,
               цена. Читать приходилось по очереди, а сравнить — никак. Ячейка
               появляется, только если за ней есть настоящее число: пустых
               обещаний в полосе быть не должно.
               Разметка aggregateRating сохранена внутри ячейки рейтинга. -->
          <!-- ⚠ FLEX, А НЕ GRID. Ячеек бывает две, три или четыре — сколько
               настоящих чисел набралось. Фиксированные grid-cols-4 оставляли
               серую дыру на подуслуге, где нет рейтинга; auto-fit вылечил
               десктоп, но на телефоне три ячейки ложились в две колонки и дыра
               возвращалась во втором ряду. У flex-wrap последний ряд просто
               растягивается на всю ширину — пустого места не остаётся ни при
               какой ширине экрана и ни при каком числе ячеек.
               Серая заливка + gap-px дают линии сетки. -->
          <dl v-if="hasFacts" class="mb-4 flex flex-wrap gap-px bg-gray-200 rounded-xl overflow-hidden border border-gray-200">
            <div v-if="set.lawyers" class="flex-1 basis-[150px] bg-white px-3.5 py-2.5">
              <dt class="flex items-center gap-1.5 text-xs text-gray-500">
                Юристов
                <!-- Текст разный по типу страницы. На подуслуге список добирается
                     юристами того же направления, когда своих меньше десяти, — и
                     число включает их. Сказать «ведут эту услугу» было бы неправдой. -->
                <FactHint title="Кого посчитали"
                          :text="secName
                            ? 'Юристы, у которых есть предложение именно по этой услуге в выбранном городе. Список ниже может быть длиннее: если своих специалистов мало, он дополняется юристами того же направления.'
                            : 'Юристы, которые ведут эту услугу в выбранном городе. Считаем всю подборку, а не только первую страницу списка.'" />
              </dt>
              <dd class="text-lg font-extrabold text-gray-900 tabular-nums">{{ set.lawyers }}</dd>
            </div>

            <div v-if="ratingValue" class="flex-1 basis-[150px] bg-white px-3.5 py-2.5"
                 itemprop="aggregateRating" itemscope itemtype="https://schema.org/AggregateRating">
              <dt class="flex items-center gap-1.5 text-xs text-gray-500">
                Рейтинг
                <FactHint title="Откуда оценка"
                          text="Среднее по всем отзывам о юристах этой подборки — и об услугах, и о самих специалистах. Сами отзывы ниже на странице." />
              </dt>
              <dd class="text-lg font-extrabold text-gray-900 tabular-nums flex items-baseline gap-1.5">
                <svg class="w-4 h-4 self-center text-yellow-300 shrink-0" fill="currentColor" viewBox="0 0 22 20" aria-hidden="true">
                  <use href="#ic-star" />
                </svg>
                <span itemprop="ratingValue">{{ ratingValue }}</span>
                <meta itemprop="bestRating" content="5" />
                <span class="text-xs font-medium text-gray-500">
                  · <span itemprop="ratingCount">{{ set.countrating }}</span> {{ reviewsWord }}
                </span>
              </dd>
            </div>

            <!-- ЦЕНА И РАСЧЁТ — ОДИН ЭЛЕМЕНТ.
                 Раньше число «от 1 000 ₽» стояло в полосе, а под ней шла ещё
                 одна плашка во всю ширину с тем же числом и тем же словом
                 «цена». Две сущности об одном, одна над другой. Теперь ячейка
                 сама раскрывает расчёт — интерактивность на месте, дубля нет.
                 Нажатая ячейка подсвечивается: иначе непонятно, что её открыло.
                 ⚠ Кнопка — накрывающий слой внутри div, а не сам ребёнок <dl>:
                 прямыми детьми списка определений могут быть только dt, dd и
                 div, кнопка там невалидна. Подпись кнопки — sr-only, видимый
                 текст остаётся в dt/dd, то есть в разметке списка. -->
            <div v-if="priceLow || set.min" class="relative flex-1 basis-[150px] px-3.5 py-2.5 transition-colors"
                 :class="priceOpen ? 'bg-indigo-50' : 'bg-white'">
              <dt class="flex items-center gap-1.5 text-xs text-gray-500">
                Цена от
                <span class="relative z-10">
                  <FactHint title="Это не оферта"
                            text="Самая низкая цена из указанных юристами на этой странице. Итог зависит от документов и сложности — точную сумму юрист называет после их изучения." />
                </span>
              </dt>
              <dd class="text-lg font-extrabold text-gray-900 tabular-nums flex items-center gap-1.5">
                {{ fmtPrice(priceLow || set.min) }} <span class="text-xs font-medium text-gray-500">₽</span>
                <svg v-if="priceRows.length" class="w-4 h-4 text-gray-400 transition-transform"
                     :class="{ 'rotate-180': priceOpen }" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </dd>
              <span v-if="priceRows.length" class="mt-0.5 block text-xs font-semibold text-indigo-700">
                {{ priceOpen ? 'Свернуть' : 'Смотреть цены' }}
              </span>
              <button v-if="priceRows.length" type="button"
                      @click="priceOpen = !priceOpen"
                      :aria-expanded="priceOpen" aria-controls="price-panel"
                      class="absolute inset-0 w-full rounded-none hover:bg-indigo-500/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-indigo-500">
                <span class="sr-only">{{ priceOpen ? 'Свернуть цены' : 'Показать цены на услуги' }}</span>
              </button>
            </div>

            <!-- СУДЫ И ПРАКТИКА — ОДНА ЯЧЕЙКА.
                 Раньше это были две сущности подряд: число «дел в практике» и
                 отдельный плакат «Что решают суды». Оба про одно, но с разными
                 числами — читатель сравнивал их вместо того, чтобы выбирать
                 юриста. Теперь одно число со своей подписью, и оно же вход в
                 разбор. Ссылка — накрывающий слой (см. соседнюю ячейку). -->
            <div v-if="courtCasesCount" class="group relative flex-1 basis-[150px] bg-white px-3.5 py-2.5">
              <dt class="flex items-center gap-1.5 text-xs text-gray-500">
                Решений судов разобрано
                <span class="relative z-10">
                  <FactHint title="Что это за решения"
                            text="Настоящие судебные акты по этой теме с нашим разбором: какие обстоятельства суд установил и чем закончилось дело. Число — по всем регионам; в блоке практики можно выбрать свой." />
                </span>
              </dt>
              <dd class="text-lg font-extrabold text-gray-900 tabular-nums">
                {{ courtCasesCount }}
              </dd>
              <span v-if="set.courtPractice" class="mt-0.5 block text-xs font-semibold text-indigo-700">
                Смотреть практику
                <svg class="inline w-3 h-3 group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </span>
              <a v-if="set.courtPractice" href="#court-practice"
                 class="absolute inset-0 hover:bg-indigo-500/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-indigo-500">
                <span class="sr-only">Что решают суды по вашему делу</span>
              </a>
            </div>
          </dl>

          <div v-if="set.uslugi" id="offers" class="scroll-mt-24">
            <div v-if="set.uslugi.data && set.uslugi.data.length" itemprop="makesOffer" itemscope itemtype="https://schema.org/AggregateOffer">
              <meta itemprop="priceCurrency" content="RUB" />
              <meta itemprop="lowPrice" :content="priceLow || set.min || 0" />
              <meta v-if="priceHigh || set.max" itemprop="highPrice" :content="priceHigh || set.max" />
              <meta itemprop="offerCount" :content="set.count || set.uslugi.data.length" />

              <!-- ПАНЕЛЬ ЦЕН. Открывается ячейкой «Цена от» в полосе выше —
                   отдельной плашки-триггера здесь больше нет, она повторяла и
                   число, и слово. Заголовок остаётся в разметке всегда (v-show
                   прячет, но не удаляет), поэтому слово, которым ищут, никуда
                   со страницы не девается. -->
              <div v-if="priceRows.length" v-show="priceOpen" id="price-panel"
                   class="my-3 rounded-xl border border-indigo-200 bg-slate-50 overflow-hidden">
                <div class="px-4 pt-4 pb-2">
                  <p class="text-sm font-semibold text-gray-900">Цена: {{ secName || mainName }}{{ cityTitle ? ' — ' + cityTitle : '' }}</p>
                  <p class="flex items-center gap-1.5 text-xs text-gray-500">
                    Отметьте нужные услуги — посчитаем примерную стоимость
                    <FactHint title="Как считается"
                              text="Складываем средние цены по отмеченным пунктам. Средняя — по анкетам юристов этой подборки, поэтому это ориентир для сравнения, а не счёт." />
                  </p>
                </div>
                <div class="px-4 pb-4">
                <ul class="space-y-1.5 text-sm list-none">
                  <li v-for="p in priceRows" :key="p.name"
                    class="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-0.5 border-b border-gray-100 last:border-0 pb-1.5 last:pb-0">
                    <label class="flex items-center gap-2 cursor-pointer select-none">
                      <input type="checkbox" v-model="selectedPrices" :value="p.name"
                        class="rounded-lg border-gray-300 text-indigo-600 focus:ring-indigo-500" />
                      <span class="text-gray-700">{{ p.name }}</span>
                    </label>
                    <span class="text-gray-500"><template v-if="p.mn !== p.mx">от {{ fmtPrice(p.mn) }} до {{ fmtPrice(p.mx) }} ₽ · </template>в среднем <span class="font-semibold text-gray-900">{{ fmtPrice(p.avg) }} ₽</span></span>
                  </li>
                </ul>
                <div v-if="selectedPrices.length"
                  class="mt-3 flex items-center justify-between border-t border-gray-200 pt-3">
                  <span class="text-sm font-semibold text-gray-900">Примерная стоимость ({{ selectedPrices.length }})</span>
                  <span class="text-lg font-extrabold text-indigo-700">≈ {{ fmtPrice(calcTotal) }} ₽</span>
                </div>
                <p class="mt-2 text-xs text-gray-500">Цены указаны юристами на странице. Всего {{ offersLine }}.</p>
                <p class="mt-1 text-xs text-gray-500">Итоговую цену уточняйте у юриста после предоставления документов.</p>
                </div><!-- /v-show priceOpen -->
              </div>
              <div v-else class="my-2 text-sm text-gray-500">Цена договорная · {{ offersLine }}</div>

              <!-- ЧТО У ВАС ПРОИЗОШЛО. Стоит до карточек: человек сначала узнаёт
                   свой случай, потом выбирает, к кому с ним идти. -->
              <section v-if="set.situations.length" class="mt-4 rounded-xl border border-gray-200 bg-gray-50/70 p-4">
                <h2 class="text-sm font-bold text-gray-900">Что у вас произошло?</h2>
                <p class="mt-0.5 text-xs text-gray-500">Выберите ситуацию — покажем, на что смотрит суд именно в ней.</p>

                <div class="mt-3 flex flex-wrap gap-2">
                  <button v-for="sit in set.situations" :key="sit.slug" type="button"
                          @click="pickSituation(sit.slug)"
                          :aria-expanded="openSituation === sit.slug"
                          class="inline-flex items-center gap-2 rounded-xl border px-3 py-2 text-sm transition-colors"
                          :class="openSituation === sit.slug
                            ? 'border-indigo-500 bg-indigo-50 text-indigo-800 font-semibold'
                            : 'border-gray-200 bg-white text-gray-700 hover:border-indigo-300'">
                    {{ sit.title }}
                    <span v-if="sit.article" class="text-xs"
                          :class="openSituation === sit.slug ? 'text-indigo-500' : 'text-gray-400'">{{ sit.article }}</span>
                  </button>
                </div>

                <div v-if="activeSituation" class="mt-3 rounded-xl border border-indigo-200 bg-white overflow-hidden">
                  <div class="bg-indigo-50 px-4 py-2.5 flex flex-wrap items-baseline gap-x-2.5">
                    <span class="text-sm font-bold text-indigo-900">{{ activeSituation.title }}</span>
                    <span v-if="activeSituation.article" class="text-xs text-indigo-500">{{ activeSituation.article }}</span>
                  </div>

                  <div class="px-4 py-3.5">
                    <p v-if="activeSituation.lead" class="text-sm text-gray-700 leading-relaxed">{{ activeSituation.lead }}</p>

                    <p v-if="activeSituation.danger"
                       class="mt-3 rounded-lg border border-rose-100 bg-rose-50 px-3 py-2 text-sm text-rose-900">
                      Чем грозит: {{ activeSituation.danger }}
                    </p>

                    <div class="mt-4 grid sm:grid-cols-2 gap-4">
                      <div v-if="activeSituation.looks.length">
                        <p class="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-1.5">На что смотрит суд</p>
                        <ul class="list-disc pl-4 text-sm text-gray-700 space-y-1 leading-snug">
                          <li v-for="(l, i) in activeSituation.looks" :key="i">{{ l }}</li>
                        </ul>
                      </div>
                      <div v-if="activeSituation.steps.length">
                        <p class="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-1.5">Что сделать в первые дни</p>
                        <ul class="list-disc pl-4 text-sm text-gray-700 space-y-1 leading-snug">
                          <li v-for="(l, i) in activeSituation.steps" :key="i">{{ l }}</li>
                        </ul>
                      </div>
                    </div>

                    <p class="mt-4 text-xs text-gray-500">
                      Это ориентир по практике, а не оценка вашего дела: суд смотрит на конкретные документы.
                      Ниже — юристы, которые ведут такие споры.
                    </p>
                  </div>
                </div>
              </section>

              <!-- card -->
              <hr class="h-px my-3 bg-gray-200 border-0" />
              <OfferCard v-for="(offer, oi) in set.uslugi.data" :key="offer.id" :offer="offer" :city="set.cities"
                :priority="oi === 0"
                :getlwr="set.getLawyer" :auth="set.auth"
                :review="set.offerReviews ? set.offerReviews[offer.user_id] : null"
                :cases="set.offerStats ? (set.offerStats[offer.id] || 0) : 0"
                :reply-note="set.replySpeed ? (set.replySpeed[offer.user_id] || '') : ''"
                :rate="set.offerRating ? (set.offerRating[offer.user_id] || null) : null"
                :perks="set.perks ? (set.perks[offer.user_id] || []) : []"
                :context="{ city: cityTitle, main: set.main_usluga?.usl_name, second: set.second_usluga?.usl_name }"
                :diplomas="set.diplomas ? (set.diplomas[offer.user_id] || null) : null"
                :invite-context="set.inviteContext"
                :invited="invitedIds"
                :invite-count="invitedIds.length"
                :invite-busy="inviteBusy"
                :online-ids="set.onlineLawyerIds"
                @toggle-invite="onToggleInvite" />
              <!-- card -->
            </div>

            <div v-else class="px-5">
              <!-- empty card -->
              <div class="flex flex-col justify-center my-10">
                <p
                  class="mb-10 flex justify-center md:justify-start text-center md:text-left text-4xl tracking-tight font-extrabold text-gray-900">
                  Не нашел своего юриста? <br />
                  Мы поможем
                </p>
                <div class="flex justify-center md:justify-start">
                  <a :href="route('questions.add')"
                    class="rounded-lg inline-block bg-brand-600 px-6 py-3.5 text-center font-medium text-white hover:bg-brand-700 focus:outline-none focus:ring-4 focus:ring-brand-200 transition-colors">
                    задать вопрос онлайн
                  </a>
                </div>
              </div>
              <hr class="h-px my-8 bg-gray-200 md:my-10 border-0 dark:bg-gray-700" />
              <!-- empty card -->
            </div>

            <!-- Юристы города без своего оффера на этой странице: направления они отметили сами
                 в кабинете (lawyer_directions). Красной кнопки здесь нет — она одна на экран. -->
            <section v-if="set.cityLawyers.length" class="px-5 py-6" aria-labelledby="city-lawyers-h">
              <h2 id="city-lawyers-h" class="text-2xl font-bold text-gray-900 mb-4">
                {{ set.uslugi.data && set.uslugi.data.length ? 'Ещё юристы' : 'Юристы' }}<template v-if="cityTitle"> — {{ cityTitle }}</template>
              </h2>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Link v-for="l in set.cityLawyers" :key="l.id" :href="'/lawyers/' + l.id"
                  class="flex gap-4 p-4 bg-white border border-gray-200 rounded-2xl hover:border-indigo-300 transition-colors">
                  <img v-if="l.avatar" :src="l.avatar" :alt="l.name" loading="lazy"
                    class="w-16 h-16 rounded-full object-cover flex-shrink-0" />
                  <div class="min-w-0">
                    <div class="text-lg font-semibold text-gray-900">{{ l.name }}</div>
                    <div class="text-sm text-gray-500 mb-1">Юрист<template v-if="l.years"> · стаж {{ l.years }} {{ yearsWord(l.years) }}</template></div>
                    <p v-if="l.about" class="text-sm text-gray-600 m-0">{{ l.about }}</p>
                    <span class="text-sm font-medium text-indigo-600">Профиль юриста →</span>
                  </div>
                </Link>
              </div>
            </section>

          </div>
        </div>
      </div>

    <!-- Пагинация офферов — сразу под списком -->
    <Pagination v-if="uslugi.total > 10" :links="uslugi.links" />

    <!-- Разбор судебной практики сразу после списка юристов: человек посмотрел, кто
         берётся за дело, и тут же видит, чем такие дела кончаются в судах его региона.
         На месте «Как мы работаем»: восемь шагов вида «Уточнение ситуации → Анализ →
         Работа» одинаковы для любой юрфирмы и человеку ничего не сообщают. Там, где
         практики по теме нет, блок этапов остаётся. -->
    <section v-if="set.courtPractice" id="court-practice" class="bg-slate-50 scroll-mt-24">
      <div class="max-w-7xl mx-auto px-4 py-8 md:py-12">
        <CourtPracticeWidget :data="set.courtPractice" />
      </div>
    </section>
    <WorkSteps v-else />

    <!-- Отзывы клиентов: соц-доказательство (schema.org/Review — в JSON-LD) -->
    <UslugaReviews :reviews="set.reviews" :meta="set.reviewsMeta" />

    <!-- Документы по услуге (ПФ: полезные PDF) -->
    <div v-if="set.documents && set.documents.length" id="documents" class="max-w-7xl mx-auto px-4 scroll-mt-24">
      <UslugaDocuments :documents="set.documents" />
    </div>

    <!-- CTA клиенту: бесплатная консультация (телефон с раскрывающейся модалкой) -->
    <section id="consultation" class="bg-white scroll-mt-24">
      <div class="max-w-7xl mx-auto px-4 py-8 md:py-12">
        <div class="rounded-2xl border border-brand-100 bg-brand-50 px-6 py-8 md:py-10 text-center">
          <h2 class="text-2xl lg:text-3xl font-extrabold text-gray-900 tracking-tight mb-2">
            Нужна консультация юриста?
          </h2>
          <p class="text-gray-600 max-w-xl mx-auto mb-6">
            Бесплатно оценим перспективы вашего дела и подскажем порядок действий. Звоните — поможем разобраться.
          </p>
          <div class="max-w-xs mx-auto">
            <RevealPhone
              :phone="'+7 978 883-89-78'"
              :phoneto="'tel:+79788838978'"
              :backendurl="set.backendurl"
              :tracking="$page.props.tracking"
              :service-name="mainName"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- Подробное описание услуги (SEO) -->
    <Seodesc id="description" class="scroll-mt-24" :blockdata="set.second_usluga ?? set.main_usluga" :city="cityTitle" />

    <Seoquestion :questiondata="set.second_usluga ?? set.main_usluga" />

    <!-- Вопросы пользователей по теме (перелинковка вопрос↔категория, свежий UGC) -->
    <UserQuestions
      :data="set.userQuestions"
      :category-name="secName || mainName"
      :city="cityTitle"
      :questions-url="set.questionsUrl" />

    <!-- Релевантные статьи внизу страницы -->
    <RelatedArticles :articles="set.articles" :practice="set.practice" />

    <!-- Связанные специализации и услуги — карта раздела перед гео-блоком -->
    <RelatedSpecialties
      :category="set.category"
      :city-url="set.city?.url || ''"
      :city-title="cityTitle"
      :main-url="set.main_usluga?.url ? String(set.main_usluga.url) : ''"
      :second-url="set.second_usluga?.url ? String(set.second_usluga.url) : ''" />

    <!-- Города, где есть наши юристы (гео-перелинковка, в самый низ) -->
    <div v-if="set.allsities" id="cities" class="max-w-7xl mx-auto px-4 py-8 md:py-12 scroll-mt-24">
      <div class="flex items-center gap-3 mb-5">
        <span class="flex-grow h-px bg-gray-200"></span>
        <h3 class="text-2xl lg:text-3xl font-extrabold tracking-tight text-gray-900 text-center">
          Города, где есть наши юристы
        </h3>
        <span class="flex-grow h-px bg-gray-200"></span>
      </div>
      <div class="flex flex-wrap gap-2 justify-center">
        <template v-for="(allcity, n) in set.allsities" :key="n">
          <a v-if="allcity.cities" :href="route('uslugi.url', [allcity.cities.url])"
            class="inline-flex items-center rounded-full bg-gray-100 hover:bg-indigo-50 hover:text-indigo-700 text-gray-600 text-sm px-4 py-1.5 transition-colors">
            {{ allcity.cities.title }}
          </a>
        </template>
      </div>
    </div>

    </Body>

    <MainFooter>
      <BreadcrumbsUslugi class="p-4 bg-white mb-2 w-full max-w-7xl mx-auto"
        :city="set.city.title !== '' ? set.city : null"
        :main_usluga="set.main_usluga.url !== 0 ? set.main_usluga : null"
        :second_usluga="set.second_usluga ? set.second_usluga : null" :usluga="null" />
    </MainFooter>

    <Tracking :key="backendurl"  :tracking="$page.props.tracking" :backendurl="set.backendurl"/>
  </div>
</template>
